import { NgIf } from '@angular/common';
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { IconModule } from '@spartacus/storefront';

@Component({
  selector: 'sd-collapsible-text',
  templateUrl: './collapsible-text.component.html',
  styleUrls: ['./collapsible-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, IconModule],
})
export class CollapsibleTextComponent implements OnChanges, AfterViewChecked {
  hidden = true;

  @HostBinding('attr.title')
  @Input()
  textContent: string;

  @HostBinding('style.--line-clamp')
  @Input()
  lineClamp = 0;

  @HostBinding('class.disabled')
  @Input()
  disabled = false;

  @HostBinding('class.collapsible')
  collapsible = false;

  @HostBinding('class.collapsed')
  collapsed = true;

  constructor(
    private cdr: ChangeDetectorRef,
    private host: ElementRef,
  ) {}

  @HostListener('click')
  handleClick(): void {
    if (this.disabled || !this.collapsible) {
      return;
    }
    this.collapsed = !this.collapsed;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.textContent.currentValue !== changes.textContent.previousValue) {
      this.collapsed = true;
      this.collapsible = false;
    }
  }

  ngAfterViewChecked(): void {
    if (this.host.nativeElement.clientHeight < this.host.nativeElement.scrollHeight) {
      if (this.hidden) {
        this.hidden = false;
        setTimeout(() => {
          this.cdr.markForCheck();
        }, 0);
      }

      if (!this.collapsible) {
        this.collapsible = true;
      }
    } else if (!this.hidden && this.collapsed) {
      this.hidden = true;
      setTimeout(() => {
        this.cdr.markForCheck();
      }, 0);
    }
  }
}
